import { DaySchedule } from '../../../types/interfaces'
import { ScheduleProps } from '../Schedule'

export const useSchedule = <T extends { schedule?: DaySchedule[] }>(
  setData: React.Dispatch<React.SetStateAction<T>>,
  data: ScheduleProps<T>['data'],
) => {
  const onChange = (value: string, item: DaySchedule, fieldName: 'from' | 'to') => {
    if (data.schedule)
      setData((prev) => ({
        ...prev,
        schedule: prev.schedule
          ? [
              ...prev.schedule.map((day) =>
                day.sequence === item.sequence ? { ...day, [fieldName]: value } : day,
              ),
            ]
          : [],
      }))
  }

  const setPattern = (pattern: Omit<DaySchedule, 'sequence'>) => {
    if (data.schedule)
      setData({
        ...data,
        schedule: data.schedule.map((day) => ({
          ...day, // сохраняем sequence
          ...pattern, // перезаписываем from, to и другие поля
        })),
      })
  }

  const sort = (a: DaySchedule, b: DaySchedule) => {
    if (a.sequence > b.sequence) {
      return 1
    } else {
      return -1
    }
  }

  const handleToggle = (el: DaySchedule) => {
    setData((prev: T) => ({
      ...prev,
      schedule: prev.schedule?.map((item) =>
        item.sequence === el.sequence ? { ...item, dayOff: !item.dayOff } : item,
      ),
    }))
  }

  return { onChange, setPattern, sort,handleToggle }
}
